import { SUPPORTED_EXCHANGES } from "@cede/types";
import { create } from "zustand";

type SubAccountRemovedStore = {
  open: boolean;
  setOpen: (open: boolean) => void;
  exchangeIds: SUPPORTED_EXCHANGES[];
  setExchangeIds: (exchangeIds: SUPPORTED_EXCHANGES[]) => void;
};

export const useSubAccountRemovedStore = create<SubAccountRemovedStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open }),
  exchangeIds: [],
  setExchangeIds: (exchangeIds: SUPPORTED_EXCHANGES[]) => set({ exchangeIds }),
}));
